import {
    AutocompleteFormField,
    DropdownBasicFormField,
    DropdownEnumFormField, MultiLangText, NotImplementedFormField,
    SwitchFormField,
    TextareaFormField,
    TextFormField
} from "./formFields/Fields";
import {postToHub, putToHub} from "../../network/actions";

export function getInitialFormValues(hubValues, fields, entityId) {
    const initialValues = {};

    if(hubValues) {
        initialValues.id = entityId;
    }

    for (const field of fields) {
        // default values when creating a new entry
        if(!hubValues) {
            initialValues[field.name] = field.defaultValue;
            continue;
        }

        // getting value from hub values
        const hubValue = hubValues[field.name];

        // if undefined leave it at default value
        if(hubValue === undefined) {
            initialValues[field.name] = field.defaultValue;
            continue;
        }

        //if explicitly null, set it to empty string
        if(hubValue === null) {
            initialValues[field.name] = "";
            continue;
        }

        // objects will get their values copied (if existing)
        // otherwise get id attribute of nested objects (for references to other entities)
        if(typeof hubValue === 'object') {
            if(hubValue.values) {
                initialValues[field.name] = {values: hubValue.values};
            }
            else {
                initialValues[field.name] = {id : hubValue.id};
            }
            continue;
        }

        // primitive values are just simply set as they are
        initialValues[field.name] = hubValue;
    }

    return initialValues;
}


const fieldComponents = {
    text: TextFormField,
    textarea: TextareaFormField,
    "dropdown-basic": DropdownBasicFormField,
    "dropdown-enum": DropdownEnumFormField,
    switch: SwitchFormField,
    autocomplete: AutocompleteFormField,
    multiLangText: MultiLangText,
};

export function getFieldComponent(type) {
    return fieldComponents[type] || NotImplementedFormField;
}


export async function submit(url, method, data, successCallback, setErrorsFunction, formFields, errorCallback = () => {}) {
    if(!validateForm(formFields, data, setErrorsFunction)) {
        return false;
    }

    try {
        if(method === "PUT") {
            const response = await putToHub(url, data);
            console.log("put response...", response);
        }

        if(method === "POST") {
            const response = await postToHub(url, data);
            console.log("post response...", response);
        }
        successCallback();
    }
    catch (e) {
        console.log("error caught in submit", e);
        errorCallback();
    }
}

function validateForm(formFields, values, setErrorsFunction) {
    const errors = {};

    formFields.forEach(field => {
        if(field.validation) {
            //loop for all validation rules and stop on first validation fail for that field
            for (let i = 0; i < field.validation.length; i++) {
                const {valid, message} = validateRule(field.validation[i], field.name, values);

                if(!valid) {
                    errors[field.name] = message;
                    break;
                }
            }
        }
    });

    setErrorsFunction(errors);

    return Object.keys(errors).length === 0;
}

function validateRule(ruleString, fieldName, values) {
    const value = values[fieldName];
    const ruleParts = ruleString.split(';');
    const rule = ruleParts[0];

    let valid = true;
    let message = "";

    switch (rule) {
        case "required" :
            valid = !!value;
            message = "Please fill out this field";
            break;

        case "required-multilang-en" :
            valid = !!value.values?.en;
            message = "Please fill out this field";
            break;

        case "required-dropdown" :
            valid = !!value;
            message = "Please select an option";
            break;

        case "numeric":
            valid = !isNaN(value);
            message = "Please use only numeric values";
            break;

        case "dropdown-basic":
            valid = value && value.id;
            message = "Please select a valid option";
            break;

        case "required-if":
            const relatedField = ruleParts[1];
            const triggerValues = ruleParts[2].split("|");
            if(triggerValues.includes(values[relatedField])) {
                valid = !!value;
                message = "Please fill out this field";
            }
            break;

        case "regex":
            //for regex we take all the rule parts following the operation, join them by , and remove first and last char (delimiters)
            const regex = new RegExp(ruleParts.slice(1).join(";").slice(1,-1));
            if(value) {
                valid = regex.test(value);
                message = "Please make sure this field is in correct format";
            }
            break;

        default:
            break;
    }

    return {valid, message};
}

export const truncateText = (text, maxLength) => {
    if (!text) {
        return "" ;
    };
    return text.length > maxLength
        ? text.slice(0, maxLength) + "..."
        : text;
};